// Mutable round data for the current puzzle. Fields are set by beginRound.
export const round = {};

export function beginRound(item) {
  Object.keys(round).forEach(k => delete round[k]);
  Object.assign(round, {
    item, guesses: [], done: false, won: false,
    images: [item.imgUrl], activeImg: 0
  });
}

export const prefs = {
  category: localStorage.getItem("pc_category") || "All"
};

export function setCategory(c) {
  prefs.category = c;
  localStorage.setItem("pc_category", c);
}
